import { FuseNavigation } from "@fuse/types";

export const navigation: FuseNavigation[] = [
    {
        id: "dashboards",
        title: "Dashboards",
        translate: "NAV.DASHBOARDS",
        type: "item",
        //type: "item",
        icon: "dashboard",
        url: "/inicio",
        hidden: true,
        children: [
            /* {
                id: "dashboard",
                title: "Dashboard",
                translate: "NAV.DASHBOARD.TITLE",
                type: "item",

                url: "/inicio",
                  badge    : {
                    title    : '25',
                    translate: 'NAV.SAMPLE.BADGE',
                    bg       : '#F44336',
                    fg       : '#FFFFFF'
                }
                hidden: true,
            },*/
        ],
    },
    {
        id: "quotes",
        title: "Quotes",
        translate: "NAV.QUOTES",
        type: "collapsable",
        icon: "attach_money",
        hidden: true,
        children: [
            {
                id: "quote",
                title: "Quote",
                translate: "NAV.QUOTE.TITLE",
                type: "item",

                url: "/cotizar",
                /*badge    : {
                    title    : '25',
                    translate: 'NAV.SAMPLE.BADGE',
                    bg       : '#F44336',
                    fg       : '#FFFFFF'
                }*/
                hidden: true,
            },
            {
                id: "myquotes",
                title: "My quotes",
                translate: "NAV.MYQUOTES.TITLE",
                type: "item",

                url: "/cotizaciones",
                hidden: true,
            },
        ],
    },
    {
        id: "orders",
        title: "Orders",
        translate: "NAV.ORDERS",
        //type: "collapsable",
        type: "item",
        icon: "work_outline",
        hidden: true,
        url: "/ordenes-de-trabajo",
        children: [
            /* {
                id: "orders",
                title: "Orders",
                translate: "NAV.ORDER.TITLE",
                type: "item",

                url: "/ordenes-de-trabajo",
                badge    : {
                    title    : '25',
                    translate: 'NAV.SAMPLE.BADGE',
                    bg       : '#F44336',
                    fg       : '#FFFFFF'
                }
                hidden: true,
            },*/
        ],
    },

    {
        id: "purchases",
        title: "Purchases",
        translate: "NAV.PURCHASEORDERS",
        //type: "collapsable",
        type: "item",
        icon: "shopping_cart",
        url: "/ordenes-de-compra",
        hidden: true,
        children: [
            /*{
                id: "purchase",
                title: "Purchase",
                translate: "NAV.PURCHASE.TITLE",
                type: "item",

                url: "/ordenes-de-compra",
                hidden: true,
            },*/
        ],
    },
    {
        id: "bills",
        title: "Bills",
        translate: "NAV.BILLS",
        icon: "monetization_on",
        //type: "collapsable",
        type: "item",
        hidden: true,
        url: "/facturas",
        children: [
            /* {
                id: "bills",
                title: "Bills",
                translate: "NAV.BILL.TITLE",
                type: "item",

                url: "/facturas",
                badge    : {
                    title    : '25',
                    translate: 'NAV.SAMPLE.BADGE',
                    bg       : '#F44336',
                    fg       : '#FFFFFF'
                }
                hidden: true,
            },*/
        ],
    },

    {
        id: "maintainers",
        title: "Maintainers",
        translate: "NAV.MAINTAINERS",
        type: "collapsable",
        icon: "label",
        hidden: true,
        children: [
            {
                id: "client",
                title: "Client",
                translate: "NAV.CLIENT.TITLE",
                type: "item",

                url: "/clientes",
                hidden: true,
            },

            {
                id: "contractors",
                title: "Contractors",
                translate: "NAV.CONTRACTORS.TITLE",
                type: "item",

                url: "/contratistas",
                hidden: true,
            },
            {
                id: "catalogue",
                title: "Catalogue",
                translate: "NAV.CATALOGUE.TITLE",
                type: "item",

                url: "/catalogo",
                hidden: true,
            },
            {
                id: "users",
                title: "Users",
                translate: "NAV.USERS.TITLE",
                type: "item",

                url: null,
                hidden: true,
            },
            {
                id: "taxs",
                title: "Tax",
                translate: "NAV.TAX.TITLE",
                type: "item",

                url: "/comunas",
                hidden: true,
            },

            {
                id: "managers",
                title: "manager",
                translate: "NAV.MANAGER.TITLE",
                type: "item",

                url: "/supervisores",
                hidden: true,
            },
        ],
    },
];
